__turbopack_context__.v({
  "banner": "takeover-top-banner-component-module-scss-module__zcK6wG__banner",
  "banner__ai-marker--above-label": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__ai-marker--above-label",
  "banner__ai-marker--beside-close": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__ai-marker--beside-close",
  "banner__ai-marker--desktop": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__ai-marker--desktop",
  "banner__ai-marker--mobile": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__ai-marker--mobile",
  "banner__ai-marker--tablet": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__ai-marker--tablet",
  "banner__close": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__close",
  "banner__image": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__image",
  "banner__label": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__label",
  "banner__link": "takeover-top-banner-component-module-scss-module__zcK6wG__banner__link",
});
